// Import the functions you need from the SDKs you need
import { initializeApp } from "firebase/app";
// TODO: Add SDKs for Firebase products that you want to use
// https://firebase.google.com/docs/web/setup#available-libraries

// Your web app's Firebase configuration
const firebaseConfig = {
  apiKey: "AIzaSyCC3jiCG2BzmS5-_YkE_zWF5hPr1OrDLqQ",
  authDomain: "shop-209b2.firebaseapp.com",
  projectId: "shop-209b2",
  storageBucket: "shop-209b2.appspot.com",
  messagingSenderId: "983944797922",
  appId: "1:983944797922:web:dda3247a9ff7de77de08bb"
};

// Initialize Firebase
const app = initializeApp(firebaseConfig);

export default app